import { vehicleService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, vehicles: [], vehicle: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        vehicleService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        vehicleService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/vehicles');
                    dispatch('alert/success', "Vehicle Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/vehicles');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        vehicleService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/vehicles');
                    dispatch('alert/success', "Vehicle Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/vehicles');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        vehicleService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      vehicleService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/vehicles');
                  dispatch('alert/success', "Vehicle Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/vehicles');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_available_vehicles({ dispatch, commit }, data) {
        commit('request');

        vehicleService.get_available_vehicles(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_vehicle_by_account({ dispatch, commit }, data) {
        commit('request');

        vehicleService.get_vehicle_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_vehicle_by_route({ dispatch, commit }, data) {
        commit('request');

        vehicleService.get_vehicle_by_route(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  vehicles: state => {
    return state.vehicles
  },
  vehicle: state => {
    return state.vehicle
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.vehicle = {};
        state.vehicles = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.vehicle = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.vehicles = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const vehicles = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
